import * as React from 'react';

const useLayoutEffect=Boolean(null===globalThis||void 0===globalThis?void 0:globalThis.document)?React.useLayoutEffect:()=>{};

export { useLayoutEffect };
